import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "react-i18next";
import TicketSearchFilters from "../search/TicketSearchFilters";

const DRAWER_WIDTH = 360;

const ReportsFilterDrawer = ({
  open,
  onClose,
  draftFilters,
  onDraftChange,
  onApply,
  onClear,
  isRTL,
  referenceData,
  userOptions,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: DRAWER_WIDTH, maxWidth: "90vw" },
      }}
    >
      <Box
        dir={isRTL ? "rtl" : "ltr"}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          textAlign: "start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.5,
          }}
        >
          <Typography variant="h6">{t("reports.filterTitle")}</Typography>
          <IconButton onClick={onClose} aria-label={t("common.close")}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />

        <Box sx={{ flex: 1, overflow: "auto", px: 2, py: 2 }}>
          <TicketSearchFilters
            filters={draftFilters}
            onChange={onDraftChange}
            isRTL={isRTL}
            referenceData={referenceData}
            userOptions={userOptions}
            showSearchField={false}
            showActionButtons={false}
            variant="drawer"
          />
        </Box>

        <Divider />
        <Box sx={{ display: "flex", gap: 1.5, p: 2 }}>
          <Button variant="outlined" fullWidth onClick={onClear}>
            {t("search.clearButton")}
          </Button>
          <Button variant="contained" fullWidth onClick={onApply}>
            {t("reports.apply")}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ReportsFilterDrawer;
